import React from "react";
import { NavLink, Redirect, Route, Switch, useLocation } from "polyrouter";
import { Layout } from "views/Main/Layouts";
import { useTranslation } from "utilities/i18n";
import { LicensingSetupRouter } from "./Setup/LicensingSetupRouter";
import { LicenseKeysRouter } from "./LicenseKeys/LicenseKeysRouter";

export const SharedLicensingRouter: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isDetailsView = pathname.includes("/details");
  const back = isDetailsView
    ? {
        to: "/manage/licensing/license-keys",
        title: t("LICENSE_KEYS"),
        iconDesc: t("LICENSE_KEYS")
      }
    : undefined;

  const { Sidebar } = Layout;
  return (
    <Layout back={back}>
      {!isDetailsView && (
        <Sidebar>
          <span className="title-capitalized">{t("LICENSING")}</span>
          <ul className="menu router">
            <li>
              <NavLink nest to="/setup">
                {t("SETUP")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/poly-plus">
                {t("POLY_PLUS")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/clariti">
                {t("CLARITI")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/license-keys">
                {t("LICENSE_KEYS")}
              </NavLink>
            </li>
          </ul>
        </Sidebar>
      )}
      <Switch nest>
        <Route path="/setup">
          <LicensingSetupRouter />
        </Route>
        <Route path="/license-keys">
          <LicenseKeysRouter />
        </Route>
        <Redirect nest to="/setup" />
      </Switch>
    </Layout>
  );
};
